<template>
  <div class="paper">

    <div
      v-if="!isRule"
      class="paper-main"
    >
      <div class="contain">
        <div class="common">
          <!-- 搜索 -->
          <div class="top clearfix">
            <div class="fl">
              <span>搜索: </span>
              <el-input
                class="searchkey-input-com"
                placeholder="请输入教师姓名"
                v-model="searchKey"
                size="small"
                @change="selectLsit(1)"
                clearable
              >
              </el-input>
              <span>校区：</span>
              <el-select
                class="search_schoolcode"
                v-model="searchSchoolCode"
                clearable
                @change="selectLsit(1)"
                size="small"
              >
                <template v-for="i of userInfo.teacherSchoolList">
                  <el-option
                    :key="i.schoolCode"
                    :label="i.schoolName"
                    :value="i.schoolCode"
                  ></el-option>
                </template>
              </el-select>
            </div>
            <div class="fr">
              <!-- 批量导入 -->
              <export-upload
                v-if="isAdmin"
                @selectLsit="exSelectLsit"
                :urlAction="exUrl"
                :exData="exData"
              ></export-upload>
              <el-button
                size="small"
                @click="dowTemplate"
                v-if="isAdmin"
              >模板下载</el-button>
              <el-button
                size="small"
                icon="iconfont icon-daochu"
                @click="importTeacher"
                v-if="isAdmin"
              >导出</el-button>
            </div>
          </div>
          <!-- 表格 -->
          <el-table
            element-loading-text="拼命加载中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255, 255, 0.9)"
            v-loading="isTableLoading"
            row-key="id"
            :data="tableData"
            stripe
            style="width: 100%"
            :header-cell-style="{background:'#EFEFEF'}"
          >
            <el-table-column
              prop="userName"
              label="教师名称"
            >
            </el-table-column>
            <el-table-column
              prop="userSex"
              label="性别"
            >
            </el-table-column>
            <el-table-column
              prop="idno"
              label="师训号"
            >
            </el-table-column>
            <el-table-column
              prop="educationDesc"
              label="学历"
            >
            </el-table-column>
            <el-table-column
              prop="graduateSchool"
              label="毕业院校"
            >
            </el-table-column>
            <el-table-column
              prop="startWorkDate"
              label="从事教育开始时间"
            >
            </el-table-column>
            <el-table-column
              prop="academicTitlesDesc"
              label="职称"
            >
            </el-table-column>
            <el-table-column
              prop="teacherDutyList[0].userDutyDescription"
              label="职务"
            >
            </el-table-column>
            <el-table-column
              v-if="isAdmin"
              label="操作"
              width="150"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  class="text-edit"
                  @click="showEdit(scope.$index, scope.row)"
                >编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <pagination
            :pageObj="pageObj"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
          ></pagination>
          <!--新增的对话框 -->
          <el-dialog
            class="add-pop"
            :visible.sync="addVisible"
            :close-on-click-modal="false"
            width="40%"
            top="5%"
          >
            <template v-slot:title>
              <div class="add-title">{{form.id ? "编 辑":"新 增" }} </div>
            </template>
            <!-- 对话框内容部分 => 匿名插槽 -->
            <el-form
              ref="form"
              :rules="rules"
              :model="form"
              label-width="80px"
            >
              <!-- 教师姓名 -->
              <el-form-item
                label="教师名称"
                prop="userName"
              >
                <el-input
                  v-model="form.userName"
                  placeholder="请输入教师名称"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="userSex"
                label="性别"
              >
                <el-radio-group v-model="form.userSex">
                  <el-radio
                    size="small"
                    label="男"
                  >男</el-radio>
                  <el-radio
                    size="small"
                    label="女"
                    class="radio-warning"
                  >女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="师训号"
                prop="idno"
              >
                <el-input
                  disabled
                  v-model="form.idno"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="职称"
                prop="academicTitles"
              >
                <el-select
                  v-model="form.academicTitles"
                  placeholder="请选择"
                >
                  <template v-for="i of dic.positional">
                    <el-option
                      :key="i.id"
                      :label="i.dicName"
                      :value="i.dicCode"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="职务"
                prop="userDuty"
              >
                <el-select
                  v-model="form.userDuty"
                  placeholder="请选择"
                >
                  <template v-for="i of dic.dutuies">
                    <el-option
                      :key="i.id"
                      :label="i.dicName"
                      :value="i.dicCode"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="学历"
                prop="education"
              >
                <el-select
                  v-model="form.education"
                  placeholder="请选择"
                >
                  <template v-for="i of dic.education">
                    <el-option
                      :key="i.id"
                      :label="i.dicName"
                      :value="i.dicCode"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="毕业院校"
                prop="graduateSchool"
              >
                <el-input
                  v-model="form.graduateSchool"
                  placeholder="请输入毕业院校"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="long_label"
                :label="'从事教育\n开始时间'"
                prop="startWorkDate"
              >
                <el-date-picker
                  class="width-form-input"
                  v-model="form.startWorkDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="请选择"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>

            <template v-slot:footer>
              <span class="dialog-footer">
                <el-button
                  @click="submitStudent"
                  type="primary"
                >提 交</el-button>
              </span>
            </template>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import PopupDel from "@/components/PopupDel.vue";
import Pagination from "@/components/Pagination.vue";
import Upload from "@/components/Upload.vue";
import ExportUpload from "@/components/ExportUpload.vue";
import { teacherKeyChange, exportExecl, downloadExecl } from "@/utils/index";
import { mapState } from "vuex";
import { mixin } from "@/mixin/mixin";
export default {
  mixins: [mixin],
  components: {
    Breadcrumb,
    PopupDel,
    ExportUpload,
    Upload,
    Pagination,
  },
  computed: {
    ...mapState([
      "isAdmin",
      "userInfo",
      "dic",
      "teacherOptions",
      "teacherLoading",
    ]),
    exData() {
      return {
        integralModel: this.menuCodeMix,
        schoolCode: this.userInfo.schoolCode,
      };
    },
  },
  data() {
    return {
      exUrl: "/imp/expTeacherArchivesInfo",
      searchKey: "",
      searchSchoolCode:"",
      form: {
        id: "",
      },
    };
  },
  methods: {
    //批量导入成功后
    exSelectLsit() {
      this.selectLsit(1);
    },
    //首页 查询首页list
    selectLsit(curPage, pageSize) {
      let homeForm = {
        schoolCode: this.searchSchoolCode?this.searchSchoolCode:this.userInfo.schoolCode,
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        pageNum: curPage || this.pageObj.current,
        pageSize: pageSize || this.pageObj.size,
        userName: this.searchKey || "",
        isAdmin: this.isAdmin / 1 ,
        operatorId: this.userInfo.userId,
      };
      this.isTableLoading = true;
      this.$axios
        .post("/user/getUserArchivesList", homeForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.pageObj.size = res.data.size;
            this.pageObj.current = res.data.current;
            this.pageObj.total = res.data.total;
            this.tableData = res.data.records;
          } else {
            this.$message({
              message: "数据获取失败",
              type: "error",
            });
          }
          this.isTableLoading = false;
        })
        .catch((err) => {
          console.log("教师error", err);
        });
    },
    //模板下载
    dowTemplate() {
      downloadExecl(
        "/tmp/ddTeacherArchivesInfo",
        "教师档案-模板-" + this.userInfo.userName
      );
    },
    importTeacher() {
      exportExecl(
        "/exp/getUserArchivesList",
        "教师档案-" + this.userInfo.userName,
        this.searchSchoolCode?this.searchSchoolCode:this.userInfo.schoolCode,
        this.pageObj.current,
        -1,
        "",
        "",
        this.searchKey,
      );
    },
    //编辑
    showEdit(index, row) {
      //重置效验样式
      this.$refs.form && this.$refs.form.resetFields();
      //查询教师的选择
      this.teacherKeyChange(row.teacherName);
      console.log("row", row);
      this.form = {
        id: row.id,
        userId: row.userId,
        userName: row.userName, //姓名
        userSex: row.userSex, //性别
        academicTitles: row.academicTitles, //职称
        academicTitlesDesc: row.academicTitlesDesc,
        education: row.education, //学历
        educationDesc: row.educationDesc,
        graduateSchool: row.graduateSchool, //毕业学校
        idno: row.idno,
        teacherNum: row.teacherNum || "", //师训号
        startWorkDate: row.startWorkDate, //开始时间
        userDuty: row.teacherDutyList
          ? row.teacherDutyList.length > 0
            ? row.teacherDutyList[0].userDuty
            : ""
          : "", //职务  打包报错？？
      };
      this.selectRow = this.form;
      this.addVisible = true;
    },
    //新增 或者 更新
    submitStudent() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            //更新
            this.form.operatorId = this.userInfo.userId;
            this.form.schoolCodes = [this.userInfo.schoolCode];
            this.form.teacherArchivesDTO = {
              academicTitles: this.form.academicTitles,
              education: this.form.education,
              graduateSchool: this.form.graduateSchool,
              startWorkDate: this.form.startWorkDate || "",
              teacherNum: this.form.teacherNum || "",
              idno: this.form.idno,
            };
            this.form.teacherDutyDTO = {
              userDuty: this.form.userDuty,
            };

            this.$axios
              .post("/user/updateTeacherInfo", this.form)
              .then((res) => {
                if (res.resultCode === 200) {
                  //重置表单
                  this.$refs.form.resetFields();
                  this.selectLsit(this.pageObj.current, this.pageObj.size);
                  this.$message({
                    message: "更新成功",
                    type: "success",
                    duration: 2000,
                    offset: 150,
                  });
                } else {
                  console.log("update else", res);
                }
                this.addVisible = false;
              })
              .catch((err) => {
                console.log("update error", err);
              });
          } else {
            console.log("保存");
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../styles/common.less";
.searchkey-input-com {
  width: 200px !important;
  margin-right: 15px !important;
}
.search_schoolcode{
  width: 222px !important;
}
</style>


